module.exports = __webpack_public_path__ + "img/vertical_7_6_8004.e402ce6a.png";